import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";

export interface TabItem {
  label: string;
  icon?: string; // Font Awesome icon class (e.g., 'fa fa-home')
  value?: any;
  disabled?: boolean;
}

@Component({
  selector: "app-tab-list",
  templateUrl: "./tab-list.component.html",
  styleUrl: "./tab-list.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TabListComponent {
  /** Array of tabs to render */
  @Input() tabs: TabItem[] = [];

  /** Currently active tab index */
  @Input() activeIndex = 0;
  @Output() activeIndexChange = new EventEmitter<number>();

  selectTab(index: number): void {
    if (this.tabs[index]?.disabled) return;
    this.activeIndex = index;
    this.activeIndexChange.emit(this.activeIndex);
  }
}
